import Checkbox from '@packages/justo-parts/lib/components/fields/Checkbox'
import SectionAccordion from '@page-components/Checkout/CheckoutV2/shared/SectionAccordion'

import useProductFiltersContext from './hooks/useProductFiltersContext'

import styles from './styles.module.css'

export default function useProductFilters() {
  const {filterTypes, productFilters, setProductFilters} = useProductFiltersContext()

  return (
    <>
      {Object.keys(filterTypes).map(filterType => {
        const filters = filterTypes[filterType]
        return (
          <div key={filterType}>
            <SectionAccordion
              initiallyOpen={true}
              headerTitle={filterType}
              containerClassName={styles.containerClassName}
              titleClassName={styles.titleClassName}
              marginClassName={styles.marginClassName}
              arrowClassName={styles.arrowClassName}>
              {Object.keys(filters).map(key => {
                return (
                  <div className={styles.filters} key={key}>
                    <Checkbox
                      key={key}
                      value={filters[key].value}
                      label={filters[key].filterName}
                      onChange={() => {
                        filterTypes[filterType][key].value = !filterTypes[filterType][key].value
                        if (filterTypes[filterType][key].value) {
                          setProductFilters([...productFilters, key])
                        } else {
                          productFilters.splice(productFilters.indexOf(key), 1)
                          setProductFilters([...productFilters])
                        }
                      }}
                    />
                    <div className={styles.quantity}>{filters[key].quantity}</div>
                  </div>
                )
              })}
            </SectionAccordion>
          </div>
        )
      })}
    </>
  )
}
